import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DocumentModalComponent } from './document-modal.component';

@NgModule({
    declarations: [
        DocumentModalComponent
    ],
    exports: [
        DocumentModalComponent
    ],
    imports: [
        CommonModule
    ]
})
export class DocumentModalModule {
}
